import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import auth from '../resources/Auth';

window.Pusher = Pusher;

let echoInstance = null;

export function getEcho() {
  if (echoInstance) return echoInstance;

  let echoConf = {
    broadcaster: 'pusher',
    key: process.env.REACT_APP_PUSHER_APP_KEY,
    cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER || 'mt1',
    wsHost: process.env.REACT_APP_PUSHER_HOST || 'ws.appinfarma.it',
    wsPort: process.env.REACT_APP_PUSHER_PORT || 443,
    wssPort: process.env.REACT_APP_PUSHER_PORT || 443,
    forceTLS: true,
    encrypted: true,
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
    authEndpoint: `${process.env.REACT_APP_API_URL}/broadcasting/auth`,
    auth: {
      get headers() {
        return {
          Authorization: `Bearer ${auth.token}`,
        };
      },
    },
  };
  echoInstance = new Echo(echoConf);

  return echoInstance;
}

export function disconnectEcho() {
  if (echoInstance) {
    echoInstance.disconnect();
    echoInstance = null;
  }
}
